import {
  EDIT_EVENT_GEO,
  EDIT_EVENT_TIME,
  EDIT_EVENT_CHOICE,
  EDIT_EVENT_HINTS,
  EDIT_EVENT_SKIP,
  EDIT_EVENT_BONUS,
  RECEIVE_IMAGEAR_URL,
  EDIT_EVENT_AR,
  REMOVE_AR_TARGET,
} from '../../constants/ActionTypes';
import { findEvent, copyQuest, touchQuestModified } from '../questsHelpers';

/**
 * Handles event triggers, geolocation, timers, quizzes, hints, skips, bonuses and AR.
 * @param {Object} state - current state of quests slice
 * @param {Object} action - dispatched Redux action
 * @returns {Object|null}
 */
export default function eventTriggerReducer(state, action) {
  let nextQuest;

  switch (action.type) {
    case EDIT_EVENT_GEO: {
      const targetQuest = (state.quests || []).find(
        (quest) => String(quest.id) === String(action.questId)
      );
      if (!targetQuest) return state;
      nextQuest = { ...targetQuest };
      const event = (nextQuest.events || []).find(
        (e) => String(e.id) === String(action.eventId)
      );
      if (event) {
        event.trigger = { ...event.trigger, geo: action.geo };
      }
      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case EDIT_EVENT_TIME: {
      const targetQuest = (state.quests || []).find(
        (quest) => String(quest.id) === String(action.questId)
      );
      if (!targetQuest) return state;
      nextQuest = { ...targetQuest };
      const event = (nextQuest.events || []).find(
        (e) => String(e.id) === String(action.eventId)
      );
      if (event) {
        event.trigger = { ...event.trigger, time: action.time };
      }
      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case RECEIVE_IMAGEAR_URL: {
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = findEvent(nextQuest.events, action.eventId);
      if (!event) return state;
      const { trigger } = event;

      if (!trigger) {
        return state;
      }

      let oldTargets = [];
      if (trigger.ar && trigger.ar != null) {
        const { targets = [] } = trigger.ar;
        oldTargets = targets;
      }

      const newTargets = [
        ...oldTargets,
        { url: action.image[0], width: 0, height: 0 },
      ];

      event.trigger = { ...event.trigger, ar: { targets: newTargets } };

      touchQuestModified(nextQuest);

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case EDIT_EVENT_AR: {
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = findEvent(nextQuest.events, action.eventId);
      if (event) {
        event.trigger = { ...event.trigger, ar: action.ar };
      }

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case REMOVE_AR_TARGET: {
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = findEvent(nextQuest.events, action.eventId);
      if (event) {
        const { trigger } = event;
        if (trigger && trigger.ar) {
          const { ar } = trigger;
          const newTargets = ar.targets.filter(
            (target, idx) => idx !== action.arTargetId
          );
          event.trigger = { ...trigger, ar: { targets: newTargets } };
        }
      }

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case EDIT_EVENT_CHOICE: {
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = (nextQuest.events || []).find(
        (e) => String(e.id) === String(action.eventId)
      );
      if (!event) return state;
      const choice = {
        contentType: 'choice',
        visible: action.visible,
        data: {
          options: action.options,
          answer: action.answer,
        },
      };
      if (!event.content) {
        event.content = [choice];
      } else {
        event.content = event.content.filter(
          (item) => item.contentType !== 'choice'
        );
        event.content = [...event.content, choice];
      }

      touchQuestModified(nextQuest);

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case EDIT_EVENT_HINTS: {
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = findEvent(nextQuest.events, action.eventId);
      if (event) {
        event.hints = action.hints;
      }
      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case EDIT_EVENT_SKIP: {
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = findEvent(nextQuest.events, action.eventId);
      if (event) {
        event.skip = { ...event.skip, ...action.skip };
        event.prevButton =
          typeof action.button === 'string' ? action.button : event.prevButton;
      }

      touchQuestModified(nextQuest);

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case EDIT_EVENT_BONUS: {
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = findEvent(nextQuest.events, action.eventId);
      if (event) {
        event.bonus = action.bonus;
      }
      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    default:
      return null;
  }
}
